module.exports = __webpack_public_path__ + "static/sunspace-logo-9780a47bcc0cb72e5d9e1f4b2ced7f1e.png";